/**
 * @generated SignedSource<<81b3e998251ca4bff43f1eadbfd1c57c>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type RentalSortField = "ADMIN_MODIFICATION" | "ADMIN_MODIFICATION_REASON" | "CANCELED_ON" | "CC_HOLD_ID" | "CHARGE_AMOUNT" | "CHARGE_ID" | "CHARGE_PENDING" | "CHARGE_PENDING_DECISION_DATE" | "CHARGE_PENDING_NOTE" | "CHARGE_PENDING_STATUS" | "CHARGE_SUCCESS" | "CHARGE_TOTAL" | "COMPLETED" | "COUPON_ID" | "CREATED_ON" | "DATA" | "DEVICE_ID" | "DISTANCE" | "DURATION" | "EFFECTIVE_GRACE_PERIOD" | "ENDED_WITHIN_GRACE_PERIOD" | "END_ADMIN_USER_ID" | "END_BY" | "END_DEVICE_ID" | "END_IMAGE_URL" | "END_LAT" | "END_LNG" | "END_LOCATION_OLD_ID" | "END_PARENT_HARDWARE_ID" | "END_RACK" | "END_TIME" | "END_TYPE" | "END_USER_RFID_CARD_ID" | "FAILED_START" | "FEES_POST_TAX_AMOUNT" | "FORCE_END_ACK" | "FORCE_END_TIME" | "FORCE_END_TYPE" | "GRACE_PERIOD" | "HARDWARE_OLD_ID" | "ID" | "IS_VOID_CHARGE" | "MEMBERSHIP_MINUTES_CONSUMED" | "OLD_ID" | "ORGANIZATION_ID" | "PARKING_CREDIT" | "PAYMENT_METHOD_ID" | "PERK_OLD_ID" | "RATE_OLD_ID" | "RATING" | "REFUND_AMOUNT" | "REFUND_COMMENT" | "REVIEW_STATUS" | "START_ADMIN_USER_ID" | "START_DEVICE_ID" | "START_LAT" | "START_LNG" | "START_LOCATION_OLD_ID" | "START_PARENT_HARDWARE_ID" | "START_RACK" | "START_TIME" | "START_TYPE" | "START_USER_RFID_CARD_ID" | "SYSTEM_ID" | "SYSTEM_OLD_ID" | "TAX_AMOUNT" | "TAX_RATE" | "TRIP_DISTANCE" | "USAGE_SUBTOTAL" | "USER_ID" | "USER_OLD_ID" | "VOIDED_ON" | "VOID_BY" | "VOID_REASON" | "WALLET_TRANSACTION_OLD_ID" | "%future added value";
export type SortOrder = "ASC" | "ASC_NULLS_FIRST" | "ASC_NULLS_LAST" | "DESC" | "DESC_NULLS_FIRST" | "DESC_NULLS_LAST" | "%future added value";
export type RentalSortInput = {
  field: RentalSortField;
  order?: SortOrder | null | undefined;
  unlocksSuccessRateInput?: RentalUnlocksSuccessRateFieldInput | null | undefined;
};
export type RentalUnlocksSuccessRateFieldInput = {
  backwardWindow?: number | null | undefined;
  unlockWindow?: number | null | undefined;
};
export type useHardwareRentalsRelayQuery$variables = {
  id: string;
  limit?: number | null | undefined;
  offset?: number | null | undefined;
  sort?: ReadonlyArray<RentalSortInput | null | undefined> | null | undefined;
};
export type useHardwareRentalsRelayQuery$data = {
  readonly getHardware: {
    readonly id: string;
    readonly rentals: ReadonlyArray<{
      readonly chargeAmount: number | null | undefined;
      readonly completed: boolean | null | undefined;
      readonly createdOn: any | null | undefined;
      readonly distance: number | null | undefined;
      readonly duration: number | null | undefined;
      readonly endImageUrl: string | null | undefined;
      readonly endLocation: {
        readonly id: string;
        readonly name: string;
      } | null | undefined;
      readonly endLocationOldId: string | null | undefined;
      readonly hardwareOldId: string | null | undefined;
      readonly id: string;
      readonly images: ReadonlyArray<any> | null | undefined;
      readonly oldId: string | null | undefined;
      readonly organizationId: string | null | undefined;
      readonly rating: number | null | undefined;
      readonly startLocation: {
        readonly id: string;
        readonly name: string;
      } | null | undefined;
      readonly startLocationOldId: string | null | undefined;
      readonly startTime: any | null | undefined;
      readonly systemId: string | null | undefined;
      readonly systemOldId: string | null | undefined;
      readonly user: {
        readonly firstName: string;
        readonly fullName: string | null | undefined;
        readonly id: string;
        readonly lastName: string;
        readonly userMemberships: ReadonlyArray<{
          readonly approvedOn: any | null | undefined;
          readonly canceledOn: any | null | undefined;
          readonly id: string;
          readonly membership: {
            readonly id: string;
            readonly name: string;
          } | null | undefined;
        }>;
      } | null | undefined;
      readonly userId: string | null | undefined;
    }>;
  } | null | undefined;
};
export type useHardwareRentalsRelayQuery = {
  response: useHardwareRentalsRelayQuery$data;
  variables: useHardwareRentalsRelayQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "id"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "limit"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "offset"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "sort"
  }
],
v1 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v2 = [
  (v1/*: any*/),
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "name",
    "storageKey": null
  }
],
v3 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "id",
        "variableName": "id"
      }
    ],
    "concreteType": "Hardware",
    "kind": "LinkedField",
    "name": "getHardware",
    "plural": false,
    "selections": [
      (v1/*: any*/),
      {
        "alias": null,
        "args": [
          {
            "kind": "Variable",
            "name": "limit",
            "variableName": "limit"
          },
          {
            "kind": "Variable",
            "name": "offset",
            "variableName": "offset"
          },
          {
            "kind": "Variable",
            "name": "sort",
            "variableName": "sort"
          }
        ],
        "concreteType": "Rental",
        "kind": "LinkedField",
        "name": "rentals",
        "plural": true,
        "selections": [
          (v1/*: any*/),
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "oldId",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "startTime",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "duration",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "distance",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "chargeAmount",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "completed",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "rating",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "userId",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "systemId",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "systemOldId",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "organizationId",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "startLocationOldId",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "endLocationOldId",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "Location",
            "kind": "LinkedField",
            "name": "startLocation",
            "plural": false,
            "selections": (v2/*: any*/),
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "Location",
            "kind": "LinkedField",
            "name": "endLocation",
            "plural": false,
            "selections": (v2/*: any*/),
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "hardwareOldId",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "createdOn",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "images",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "endImageUrl",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "User",
            "kind": "LinkedField",
            "name": "user",
            "plural": false,
            "selections": [
              (v1/*: any*/),
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "fullName",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "firstName",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "lastName",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "UserMembership",
                "kind": "LinkedField",
                "name": "userMemberships",
                "plural": true,
                "selections": [
                  (v1/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "approvedOn",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "canceledOn",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "Membership",
                    "kind": "LinkedField",
                    "name": "membership",
                    "plural": false,
                    "selections": (v2/*: any*/),
                    "storageKey": null
                  }
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "useHardwareRentalsRelayQuery",
    "selections": (v3/*: any*/),
    "type": "RootQueryType",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "useHardwareRentalsRelayQuery",
    "selections": (v3/*: any*/)
  },
  "params": {
    "cacheID": "5efd7394b3a4dacfe86ba6679fa2ca94",
    "id": null,
    "metadata": {},
    "name": "useHardwareRentalsRelayQuery",
    "operationKind": "query",
    "text": "query useHardwareRentalsRelayQuery(\n  $id: ID!\n  $limit: Int\n  $offset: Int\n  $sort: [RentalSortInput]\n) {\n  getHardware(id: $id) {\n    id\n    rentals(limit: $limit, offset: $offset, sort: $sort) {\n      id\n      oldId\n      startTime\n      duration\n      distance\n      chargeAmount\n      completed\n      rating\n      userId\n      systemId\n      systemOldId\n      organizationId\n      startLocationOldId\n      endLocationOldId\n      startLocation {\n        id\n        name\n      }\n      endLocation {\n        id\n        name\n      }\n      hardwareOldId\n      createdOn\n      images\n      endImageUrl\n      user {\n        id\n        fullName\n        firstName\n        lastName\n        userMemberships {\n          id\n          approvedOn\n          canceledOn\n          membership {\n            id\n            name\n          }\n        }\n      }\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "bc6bcc972ce04a3fdecab7a4bb74dd86";

export default node;
